import { createContext, useContext, useState } from 'react';
import { useConversationsContext } from '@/context/conversation-context';
import { useWhatsAppEvents } from '@/context/whatsapp-events-context';
import NewWhatsAppConversationModal from './conversation-whatsapp-create-modal';
import { DefaultConversationFormData } from '../conversations.types';

const CreateWhatsappConversationContext = createContext({
  isNewConversationModalOpen: false,
  setIsNewConversationModalOpen: (isOpen: boolean) => {
    console.log('setIsNewConversationModalOpen', isOpen);
  },
  handleConversationCreated: (conversationId: string) => {
    console.log('handleConversationCreated', conversationId);
  },
});

export const CreateWhatsappConversationProvider = ({
  defaultData,
  children,
  refetchUserByPhone,
}: {
  children: React.ReactNode;
  defaultData?: DefaultConversationFormData;
  refetchUserByPhone: () => void;
}) => {
  const hasDefaultData = !!(
    defaultData &&
    defaultData.phoneNumber &&
    defaultData.userFirstName &&
    defaultData.userLastName
  );

  const [isNewConversationModalOpen, setIsNewConversationModalOpen] =
    useState(hasDefaultData);

  const { refreshConversations } = useConversationsContext();

  const { setSelectedConversationIdForContext } = useWhatsAppEvents();

  // Handle new conversation creation
  const handleConversationCreated = (conversationId: string) => {
    refreshConversations();
    refetchUserByPhone();
    setSelectedConversationIdForContext(conversationId);
  };

  const context = {
    isNewConversationModalOpen,
    setIsNewConversationModalOpen,
    handleConversationCreated,
  };

  return (
    <CreateWhatsappConversationContext.Provider value={context}>
      {children}
      <NewWhatsAppConversationModal
        isOpen={isNewConversationModalOpen}
        onClose={() => {
          setIsNewConversationModalOpen(false);
        }}
        onConversationCreated={handleConversationCreated}
        defaultData={defaultData}
      />
    </CreateWhatsappConversationContext.Provider>
  );
};

export const useCreateWhatsappConversation = () => {
  const context = useContext(CreateWhatsappConversationContext);
  if (context === undefined) {
    throw new Error(
      'useCreateWhatsappConversationContext must be used within a CreateWhatsappConversationContext',
    );
  }
  return context;
};
